// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
// custom components
import NumberedHeading from '../../../../../../shared-components/forms/NumberedHeading';

const EnvironmentDetails = (props) => {
  const { control, errors } = props;

  return (
    <>
      <NumberedHeading
        number="1"
        title="Environment Character"
        instructions="Fill The characters name such as FAO."
        required
      />
      <Controller
        control={control}
        name="content.environment.character"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Character Name"
            placeholder="Character Name"
            id="character_name"
            error={!!errors.content?.environment?.character}
            helperText={errors.content?.environment?.character?.message}
            variant="outlined"
            fullWidth
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="2"
        title="Environment Location"
        instructions="Fill in the name of the environment location such as Office, Conference Room, Cafe or what ever else."
        required
      />
      <Controller
        control={control}
        name="content.environment.location"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Location"
            placeholder="Location"
            id="location"
            error={!!errors.content?.environment?.location}
            helperText={errors.content?.environment?.location?.message}
            variant="outlined"
            fullWidth
            multiline
            minRows={5}
            maxRows={10}
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="3"
        title="Environment Description"
        instructions="Fill in a description of the environment. This should provide a granular level of detail for the dev team/artist to create said environment."
        required
      />
      <Controller
        control={control}
        name="content.environment.description"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Environment Description"
            placeholder="Environment Description"
            id="enviroment_description"
            error={!!errors.content?.environment?.description}
            helperText={errors.content?.environment?.description?.message}
            variant="outlined"
            fullWidth
            multiline
            minRows={5}
            maxRows={10}
            required
          />
        )}
      />
    </>
  );
};

export default EnvironmentDetails;
